import csv from "csvtojson";
import { readFile } from "../utils";
import SearchInput from "../../SearchInput";

const TableActions = (props) => {
	const { searchValue, setSearchValue, updateItems, elementName, items, arrayItems, disabled } = props;

	const handleImportFileChange = (e) => {
		Array.from(e.target.files).forEach((file) => {
			// Create temporary file path
			const filePath = URL.createObjectURL(file);
			const { type } = file;

			readFile(filePath, (fileValue) => {
				if (type === "application/json") {
					const parsedJson = JSON.parse(fileValue);
					if (Array.isArray(parsedJson)) {
						setItemsFromJson(parsedJson);
					}
				} else if (type.includes("text/")) {
					csv({ output: "json" })
						.fromString(fileValue)
						.then((jsonResult) => {
							setItemsFromJson(jsonResult);
						});
				}
			});
		});
	};

	const handleExportClick = async () => {
		const json = JSON.stringify(items);
		const blob = new Blob([json], { type: "application/json" });
		const href = await URL.createObjectURL(blob);
		const link = document.createElement("a");

		link.href = href;
		link.download = elementName + ".json";

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	const setItemsFromJson = (dataArray) => {
		let newTableItems = [];

		dataArray.forEach((item) => {
			let tableItem = {};

			// Grab the relevant element data from the JSON item
			arrayItems.forEach((element) => {
				tableItem[element.elementName] = item[element.elementName];
			});

			// Add the table item only if it at least has 1 element value
			if (Object.keys(tableItem).length > 0) {
				newTableItems.push(tableItem);
			}
		});

		updateItems([...items, ...newTableItems]);
	};

	return (
		<div style={{ marginTop: 8, marginBottom: 8 }}>
			<SearchInput
				containerStyle={{ width: 236 }}
				value={searchValue}
				onChange={(e) => setSearchValue(e.target.value)}
			/>
			{/* <div>

                <label
                    htmlFor={`${elementName}-search`}
                    className="form-label d-flex justify-content-start">
                    <span style={{ fontSize: 12, fontWeight: 700 }}>{t('search')}</span>
                </label>
                <input
                    id={`${elementName}-search`}
                    type="text"
                    value={searchValue}
                    className="form-control-sm d-flex justify-content-start border-4 border-top-0 border-end-0 border-start-0"
                    onChange={(e) => setSearchValue(e.target.value)}
                />
            </div> */}
			{/* <div style={{ width: 'fit-content', marginLeft: 'auto' }}>
                <button
                    disabled={disabled}
                    style={{ marginRight: 8 }}
                    onClick={() => document.getElementById(`import-${elementName}`).click()}
                    className="btn btn-sm btn-success">
                    {t('import')}
                </button>

                <input
                    disabled={disabled}
                    id={`import-${elementName}`}
                    onChange={handleImportFileChange}
                    type="file"
                    style={{ display: "none" }}
                />

                <button
                    disabled={disabled}
                    className="btn btn-sm btn-danger"
                    onClick={handleExportClick}>
                    {t('export')}
                </button>
            </div> */}
		</div>
	);
};

export default TableActions;
